import React from 'react';
import Bar from '../components/Bar';
import Footer from '../components/Footer';


import {
  useParams
} from 'react-router';
import Price from './Price';


const FormPrice = () => {

  let { language } = useParams();
  console.log(language);
  return (
    <>
      <Bar/>
      <main>
        <Price/>
        <Footer/>
      </main>
      
    </>
  )
};

export default FormPrice;
